// Inspired by https://overreacted.io/making-setinterval-declarative-with-react-hooks/
import { useEffect, useRef } from "react";

export const useInterval = (callback: () => void, delay: number | null) => {
  const callbackRef = useRef(callback);
  const intervalRef = useRef<NodeJS.Timeout>(null as unknown as NodeJS.Timeout);

  useEffect(() => {
    if (delay !== null) {
      intervalRef.current = setInterval(callbackRef.current, delay);
      return () => clearInterval(intervalRef.current);
    }
    return () => {};
  }, [delay]);

  const resetInterval = () => {
    if (delay !== null) {
      clearInterval(intervalRef.current);
      intervalRef.current = setInterval(callbackRef.current, delay);
    }
  };
  return resetInterval;
};
